import { propertyMapping, PropertyMapping } from '@hakla/typed-forms'
import { DevelopmentSettings } from '@/shared/development/models/development-settings'

export interface DevelopmentSettingsForm {
  delayActive: boolean
  delayMax: number
  delayMin: number
  killUrls: string
}

export function developmentSettingsFormMapping(): PropertyMapping<
  DevelopmentSettings,
  DevelopmentSettingsForm
> {
  return propertyMapping(({ generic, int }) => {
    return {
      delayActive: generic('delayActive', 'delay.active'),
      delayMax: int('delayMax', 'delay.max'),
      delayMin: int('delayMin', 'delay.min'),
      killUrls: generic('killUrls')
        .deserializeWith(value => value.killUrls?.join('\n') || '')
        .serializeWith((model, form) => {
          model.killUrls = form.killUrls?.split('\n').map(url => url.trim()) ?? ''
        }),
    }
  })
}
